module.exports = __webpack_public_path__ + "img/ondago_logo_gradient.e53d5ddb.png";